/**
 * Canonical app route paths. Use these for redirects and navigation
 * so the post-login landing stays consistent (dashboard).
 */
export const DASHBOARD_PATH = "/dashboard";
